import { inject, observer } from "mobx-react";
import React, { Component, Fragment } from "react";
import { Helmet } from "react-helmet";
import Main from "./main";
import ScrollToTop from "./components/ScrollToTop";

@inject("AppStore")
@observer
class App extends Component {
  render() {
    return (
      <Fragment>
        <Helmet htmlAttributes={{ lang: process.env.REACT_APP_LANG }}></Helmet>
        <ScrollToTop />
        <Main />
      </Fragment>
    );
  }
}

export default App;
